import React, {useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';

import {Container, Divider, Grid, LinearProgress} from '@mui/material';


import {PageHeader} from '../../common';
import {FetchContext, NavContext} from '../../contexts';
import {EccezioniList, UfficioDetails} from './components';
import {
    StoricoUfficioComuneCompetenzaContext,
    StoricoUfficioComuneCompetenzaProvider
} from './StoricoUfficioComuneCompetenzaContext';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingStoricoUfficioComuneCompetenza,
        getStoricoUfficioComuneCompetenzaAsync,
    } = useContext(StoricoUfficioComuneCompetenzaContext)

    const {
        storicoUfficioComuneCompetenza
    } = state;

    const {
        comuneId,
        competenzaId,
        storicoId,
    } = useParams();

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingStoricoUfficioComuneCompetenza);
    }, [isLoadingStoricoUfficioComuneCompetenza])

    useEffect(() => {
        if (user && storicoUfficioComuneCompetenza)
            addBreadcrumbToken(`Storico competenza "${storicoUfficioComuneCompetenza.dataCreazione.toLocaleString("it-IT")}"`);
    }, [storicoUfficioComuneCompetenza, user]);

    useEffect(() => {
        if (user && storicoId)
            getStoricoUfficioComuneCompetenzaAsync(comuneId, competenzaId, storicoId);
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress/>}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            title={storicoUfficioComuneCompetenza && `Storico competenza del ${storicoUfficioComuneCompetenza.dataCreazione.toLocaleString("it-IT")} - ${storicoUfficioComuneCompetenza.creatoDaUtente?.nome} ${storicoUfficioComuneCompetenza.creatoDaUtente?.cognome}`}
                            subtitle={`Visualizza cambiamenti`}/>
                    </Grid>
                    {/* <Grid item xs={12} sx={{ marginTop: 3 }}>
                        <ComuneDetails />
                        <Divider />
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 3 }}>
                        <CompetenzaDetails />
                        <Divider />
                    </Grid> */}
                    <Grid item xs={12} sx={{marginTop: 3}}>
                        <UfficioDetails/>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12} sx={{marginTop: 3}}>
                        <EccezioniList/>
                        <Divider/>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const StoricoUfficioComuneCompetenzaPage = () => {

    return (
        <StoricoUfficioComuneCompetenzaProvider>
            <PageContent/>
        </StoricoUfficioComuneCompetenzaProvider>
    );
}